import $ from 'jquery';
import { uploadUri } from '../appConfig';

const generateThemeBlock = (theme) => {
	const template = $('._template-block > .image-block').clone();
	template.find('.title').text(theme.title);
	template.attr('href', `themes/${theme.id}`);
	template.attr(
		'style',
		`background-image: url(${uploadUri}/${theme.cover})`,
	);

	return template.prop('outerHTML');
};

export default generateThemeBlock;



// WEBPACK FOOTER //
// ./src/js/theme/generateThemeBlock.js